/** True for `/admin` and `/admin/...`, including query/hash suffixes. */
export function isAdminPath(path: string): boolean {
  const pathname = path.split(/[?#]/, 1)[0] ?? path
  return pathname === "/admin" || pathname.startsWith("/admin/")
}

/**
 * Full-document navigation into admin so CloudFront/WAF sees the request.
 * Soft React Router nav never hits the edge and would bypass the VPN gate.
 */
export function enterAdmin(path = "/admin", opts?: { replace?: boolean }): void {
  if (opts?.replace) {
    window.location.replace(path)
    return
  }
  window.location.assign(path)
}
